import Vue from 'vue'

const Fn = {
  formatDataQa (name, prefix, suffix) {
    if (!name || (typeof name !== 'string' && typeof name !== 'number')) return null // ถ้า return null data attribute จะไม่โชว์
    if (prefix && (typeof prefix === 'string' || typeof prefix === 'number')) name = `${prefix}-${name}`
    if (suffix && (typeof suffix === 'string' || typeof suffix === 'number')) name = `${name}-${suffix}`
    return name
      .toString()
      .replace(/[\W_]+/g, '-') // replace ทุกๆ character ที่ไม่ใช่ word character (มีค่าเท่ากับ [^A-Za-z0-9_]) และ _ ให้เป็น '-' ,, ใส่ + จะทำให้ --- เหลือแ่ค่ - เดียว
      .replace(/\W$/, '') // replace character ตัวสุดท้าย ที่ไม่ใช่ word character ให้เป็น ''
      .toLowerCase()

    //  https://devahoy.com/blog/2016/11/regular-expressions-101, https://www.rexegg.com/regex-quickstart.html
    //  [abc]  =  a, b หรือ c อย่างใดอย่างหนึ่ง
    //  \W     =  ที่ไม่ใช่ตัวอักษร
    // eslint-disable-next-line no-tabs
    //  +	     =  หมายถึงหนึ่งหรือมากกว่า เช่น n+ คือมี n อย่างน้อยหนึ่งตัว
    //  /g     =  global เพื่อให้ match ทั้งหมด ไม่เฉพาะตัวแรกเท่านั้น
    //  $      =  สัญลักษณ์สิ้นสุดของ String เช่น d$ มี d ลงท้ายประโยค จะ match Thailand, Poland, England แต่ละไม่ match Spain
  },
  checkConfig ({ name, val = 'value', key = 'config_dict', state }) {
    return state && state.custom_config && state.custom_config[key] && state.custom_config[key][name] && state.custom_config[key][name][val]
  }
}

Vue.prototype.$fn = Fn
export default Fn
